import { type ClassValue, clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

// Every scale `globals.css` adds. Unnamed, tailwind-merge reads `text-label` as a colour, drops
// `text-primary-foreground` as conflicting, and a filled button's label falls to 1.3:1.
const twMerge = extendTailwindMerge<"focus-ring">({
  extend: {
    // A caller's `focus-ring-inset` replaces a primitive's `focus-ring` rather than losing to it.
    classGroups: { "focus-ring": ["focus-ring", "focus-ring-inset"] },
    theme: {
      text: [
        "display",
        "display-narrow",
        "heading",
        "subheading",
        "panel-title",
        "lead",
        "title",
        "row",
        "body",
        "reading",
        "nav",
        "rail-head",
        "label",
        "small",
        "note-title",
        "note",
      ],
      radius: ["row", "popup", "group", "card", "panel"],
      shadow: [
        "lift-1",
        "raised",
        "lift-2",
        "lift-3",
        "pressed",
        "pressed-fill",
        "focus",
        "invalid",
      ],
      ease: ["ui", "exit"],
      color: [
        "canvas-from",
        "canvas-via",
        "canvas-to",
        "sidebar-group",
        "selected",
        "secondary-from",
        "secondary-to",
        "keycap",
        "edge",
        "row-hover",
        "sheen",
        "overlay",
        "viewer",
        "viewer-foreground",
        "viewer-muted",
        "viewer-control",
        "viewer-control-strong",
        "foreground-soft",
        "headline-quiet",
        "icon",
        "primary-text",
        "primary-from",
        "primary-to",
        "primary-hover-from",
        "primary-hover-to",
        "primary-pressed-from",
        "primary-pressed-to",
        "primary-edge",
        "switch-on",
        "destructive-foreground",
        "success",
        "warning",
        "info",
        "toast-from",
        "toast-to",
        "toast-foreground",
        "toast-edge",
        "toast-action",
      ],
    },
  },
});

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
